export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_smart-workflows-18/artifacts/ckbn2bit_Transparent%20Logo%20for%20Website%20%28PNG%29.png";

export const CONTACT_EMAIL = "hello@etradinggroup.com.au";
export const LOCATION = "Sydney, NSW, Australia";

export const BOOK_REVIEW_MAILTO =
  `mailto:${CONTACT_EMAIL}?subject=Book%20a%20Business%20Systems%20Review&body=Hi%20ETradingGroup%2C%0A%0AI%27d%20like%20to%20book%20a%20Business%20Systems%20Review.%0A%0AName%3A%20%0ABusiness%3A%20%0APhone%3A%20%0AWhat%20I%27m%20looking%20to%20reimagine%3A%20%0A%0AThanks.`;
